export const eventNames = {
  'Wines from Spain Annual Tasting (exporters) - 2021': 'Exporters',
  'Wines from Spain Annual Tasting (importers) - 2021': 'Importers',
};
